import { Controller } from 'stimulus';

class CartSummaryController extends Controller {
  setShippingCosts(price) {
    this.shippingCosts = price;
    this.recalculate();
  }

  update() {
    $.get({
      url: window.location.href,
      success: (res) => {
        const $cartSummary = $(res).find('[data-controller="cart-summary"]');

        if ($cartSummary.length) {
          this.element.innerHTML = $cartSummary.html();
        }
      },
    });
  }
}

CartSummaryController.targets = [
  'shippingCosts',
  'shippingCostsWrapper',
  'total',
  'couponValue',
];

export default CartSummaryController;
